
import { CustomNavigate } from "@UI/CustomNavigate"
import './styles.css'

const ComprobantDetailPaymentHeader = () => {

  return (
    <header>
      <small className="new-edit-collection-template-subtitle">
        ADMINISTRACIÓN DE COBROS / DETALLES DE COMPROBANTE DE PAGO
      </small>
      <CustomNavigate title={
        'COMPROBANTE DE PAGO'
      }>
      </CustomNavigate>
    </header>
  )
}

export default ComprobantDetailPaymentHeader
